import { render } from "./Subnavbar.vue?vue&type=template&id=6d9bceac"
const script = {}
script.render = render

export default script